import { useEffect } from 'react'

import useAppDispatch from '../../../store/hooks/useAppDispatch'
import { outletForceRefreshMenuIfNeeded } from '../store/outletSlice'

// The underlying check only flips once a new clock-minute has passed
const ForceRefreshMenuActivityThrottleMs = 60_000

/** Re-checks for menu-window changes when the user returns and is active, instead of polling while idle/away */
export default function useForceRefreshMenuOnActivity() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    let lastCheckedAt = 0

    function checkForMenuRefresh() {
      if (document.visibilityState !== 'visible') return

      const now = Date.now()
      if (now - lastCheckedAt < ForceRefreshMenuActivityThrottleMs) return

      lastCheckedAt = now
      dispatch(outletForceRefreshMenuIfNeeded())
    }

    document.addEventListener('visibilitychange', checkForMenuRefresh)
    window.addEventListener('focus', checkForMenuRefresh)
    window.addEventListener('pointerdown', checkForMenuRefresh)
    window.addEventListener('keydown', checkForMenuRefresh)

    return () => {
      document.removeEventListener('visibilitychange', checkForMenuRefresh)
      window.removeEventListener('focus', checkForMenuRefresh)
      window.removeEventListener('pointerdown', checkForMenuRefresh)
      window.removeEventListener('keydown', checkForMenuRefresh)
    }
  }, [dispatch])
}
